import { GenericLazyString } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import Divider from '../../../divider/Divider';
import { useTheme } from '../../../theme-context';

interface ISectionLine {
    info: {
        name: string;
        color: string;
        seatsAvailableLabel: GenericLazyString;
        priceLabel: GenericLazyString;
    };
}

const SectionLine = ({ info }: ISectionLine): React.ReactElement => {
    const { name, color, seatsAvailableLabel, priceLabel } = info || {};
    const { getFont } = useTheme();

    return (
        <div>
            <Divider />

            <div>
                <div
                    className={css({
                        display: 'grid',
                        gridTemplateColumns: 'fit-content(100%) auto',
                    })}
                >
                    <div
                        className={css({
                            background: color,
                            width: '4px',
                        })}
                    />

                    <div
                        className={css({
                            display: 'grid',
                            gridTemplateColumns: 'fit-content(100%) auto',
                            justifyItems: 'end',
                            alignContent: 'space-between',
                            alignItems: 'center',
                            padding: '8px 16px 12px 12px',
                        })}
                    >
                        <div>
                            <div>
                                <p
                                    data-testid="tier-name"
                                    className={css({
                                        fontFamily: getFont(
                                            'desktop/body/medium/bold',
                                        ).fontFamily,
                                        fontWeight: getFont(
                                            'desktop/body/medium/bold',
                                        ).fontWeight,
                                        fontSize: getFont(
                                            'desktop/body/medium/bold',
                                        ).fontSize,
                                    })}
                                >
                                    {name}
                                </p>
                                <p
                                    data-testid="seats-available-label"
                                    className={css({
                                        fontFamily:
                                            getFont('desktop/body/small')
                                                .fontFamily,
                                        fontWeight:
                                            getFont('desktop/body/small')
                                                .fontWeight,
                                        fontSize:
                                            getFont('desktop/body/small')
                                                .fontSize,
                                    })}
                                >
                                    {seatsAvailableLabel}
                                </p>
                            </div>
                        </div>
                        <div
                            className={css({
                                justifySelf: 'self-end',
                                fontFamily: getFont('desktop/body/medium')
                                    .fontFamily,
                                fontWeight: getFont('desktop/body/medium')
                                    .fontWeight,
                                fontSize: getFont('desktop/body/medium')
                                    .fontSize,
                            })}
                        >
                            <div data-testid="price-label">
                                <p>{priceLabel}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SectionLine;
